/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Badge, Checkbox, Divider, FormControlLabel, Grid, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { ImProfile } from "react-icons/im";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

import { AiOutlineWechat } from "react-icons/ai";
import { MdEmail, MdOutlineMarkEmailRead } from "react-icons/md";
import { AlertMsg, AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import AOS from "aos";
import Collapse from '@mui/material/Collapse';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { BtnChangePassword, BtnConfirm, BtnDelete } from 'components/Common/Button';
import ModalChangePassword from './ModalChangePassword';
import CpnPopUpMap from 'view/BackEnd/CreateVOC/ComponentVOC/CpnPopUpMap';
import UploadProfile from 'components/Common/ElementInForm/UploadProfile/UploadProfile';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import {DeleteForever} from "@mui/icons-material";
import UserAvatar from "../../../assets/Image/user-avatar.png";
import { styled } from '@mui/material/styles';

import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.Profile.fields';
const i18nFieldCommon = "common";


const SmallAvatar = styled(Avatar)(() => ({
    width: 22,
    height: 22,
    border: `2px solid #fff`,
  }));

const Profile = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout900 = useMediaQuery('(min-width:900px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');

    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sPathImage": null,
        "sAPIRoleName": null,
        "sUserType": null,
    })
    const [sUserID, setsUserID] = useState("")
    const [IsAddAddress, setIsAddAddress] = useState(false)
    const [IsRequireInputTel, setIsRequireInputTel] = useState(false)
    const [IsOpenPassword, setIsOpenPassword] = useState(false)
    const [IsOpenMap, setIsOpenMap] = useState(false)

    const [arrProfile, setarrProfile] = useState([] as any)


    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [OptionTitle, setOptionTitle] = useState([] as any);
    const [OptionCompany, setOptionCompany] = useState([] as any);
    const [OptionAddress, setOptionAddress] = useState([] as any);
    const [OptionTel, setOptionTel] = useState([] as any);
    const [isAutoCreate, setisAutoCreate] = useState(false)
    const onClearFile = useRef(null);

    const [isSetMap, setIsSetMap] = useState(false)
    const [oLocationCurrent, setoLocationCurrent] = useState({
        lat: null,
        lng: null,
    })
    const [sLocation, setsLocation] = useState({
        Latitude: null,
        Longitude: null,
        Address: null,
    })
    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)


    let objSchema = {
        oTitle: yupFormSchemas.object(i18n(`${i18nField}.sTitle`), { required: DataUser.sUserType === "C" ? true : false }),
        sPTTOwner: yupFormSchemas.string(i18n(`${i18nField}.sPTTOwner`), { required: false }),
        sFirstname: yupFormSchemas.string(i18n(`${i18nField}.sFirstname`), { required: DataUser.sUserType === "C" || DataUser.sUserType === "O" ? true : false }),
        sLastname: yupFormSchemas.string(i18n(`${i18nField}.sLastname`), { required: DataUser.sUserType === "C" || DataUser.sUserType === "O" ? true : false }),
        oCompany: yupFormSchemas.object(i18n(`${i18nField}.sCompany`), { required: false }),
        oAddress: yupFormSchemas.object(i18n(`${i18nField}.sAddress`), { required: DataUser.sUserType === "C" ? true : false }),
        sInputAddress: yupFormSchemas.string(i18n(`${i18nField}.sAddress`), { required: IsAddAddress }),
        oTel: yupFormSchemas.object(i18n(`${i18nField}.sTel`), { required: DataUser.sUserType === "C" && isAutoCreate != true ? true : false }),
        // sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: IsRequireInputTel }),
        sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: IsRequireInputTel, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sEmail: yupFormSchemas.email(i18n(`${i18nField}.sEmail`), { required: DataUser.sUserType === "O" ? true : false }),
    }

    const schema = yup.object().shape(objSchema);

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetOptionALL();
    }, [])

    useEffect(() => {
        if (sLocation.Address != null) {
            form.setValue("sInputAddress", sLocation.Address)
            form.clearErrors("sInputAddress")
        }
    }, [sLocation.Address, isSetMap])


    const GetOptionALL = async () => {
        let nUserID = 0;
        let sUserID = "";
        let lstIntBA = [] as any;

        BlockUI();
        await AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                nUserID = res.result.nUserID;
                lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);

                if (res.result.IsReset == true) {
                    setTimeout(() => {
                        setIsOpenPassword(true)
                    }, 1000);
                }
                if (res.result.sPathImage) {
                    const img = new Image()
                    img.src = res.result.sPathImage
                    var result = new Promise((resolve) => {
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                    });
                    result.then(reustItem => {
                        var img = reustItem ? res.result.sPathImage : UserAvatar
                        res.result.sPathImage = img;
                    })
                } else {
                    res.result.sPathImage = UserAvatar;
                }

                setDataUser({
                    "nUserID": res.result.nUserID || 0,
                    "sUserCode": res.result.sUserCode || "",
                    "sPathImage": res.result.sPathImage || null,
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                });
            })
        })

        await AxiosGet(`MasterData/EncrypData`, { "sDataEncryp": nUserID }, (res) => {
            ResultAPI(res, null, () => {
                sUserID = res.result;
                setsUserID(res.result)
            })
        });

        await AxiosPost(`Company/GetCustomerCompany`, { "sLanguage": currentLanguage(), "IsAdd": true }, (res) => {
            ResultAPI(res, null, () => {
                setOptionCompany(res.result.data || [])
            })
        })
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 1, "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setOptionTitle(res.result?.data || [])
            })
        });

        await AxiosGet(`User/GetUserTelById`, { "sLanguage": currentLanguage(), "nUserID": nUserID, "IsAdd": true }, (res) => {
            ResultAPI(res, null, () => {
                setOptionTel(res.result.data || [])
            })
        });

        await AxiosGet(`Customer/GetDefaultDataCustomer`, { "sLanguage": currentLanguage(),"sUserID": sUserID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                form.setValue("oTitle", res.oTitle)
                form.setValue("sFirstname", res.sFname)
                form.setValue("sLastname", res.sLname)
                form.setValue("oCompany", res.oDefaultCompany ?? null)
                form.setValue("oAddress", res.oDefaultAddress ?? null)
                form.setValue("oTel", res.oDefaultTel ?? null)
                form.setValue("sEmail", res.sEmail ?? null)
                if (res.oEmployee.value != null) {
                    form.setValue("sPTTOwner", res.oEmployee.label ?? null)
                }
                setisAutoCreate(res.IsAutoCreate)

                let nCompanyID = res?.oDefaultCompany?.value;

                if (nCompanyID) {
                    AxiosGet(`Company/GetCompanyAddress`, { "nUserID": nUserID, "nCompanyID": nCompanyID, "IsAdd": false }, (res) => {
                        ResultAPI(res, null, () => {
                            setOptionAddress(res.result.data || [])

                        })
                    });
                }

            })
        });

    }

    const onSaveProfile = () => {

        let objParam = {
            "nTitleID": form.getValues("oTitle") ? parseInt(form.getValues("oTitle").value) : null,
            "nTelID": form.getValues("oTel") ? parseInt(form.getValues("oTel").value) : null,
            "sFirstName": form.getValues("sFirstname") ?? null,
            "sLastName": form.getValues("sLastname") ?? null,
            "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
            "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,
            "sTel": form.getValues("sInputTel") ?? null,
            "sExtension": form.getValues("sInputTelExtension") ?? null,
            "sEmail": form.getValues("sEmail") ?? null,
            "sUserID": sUserID,
            "cMoreAddress": {
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "sAddress": form.getValues("sInputAddress") ?? null,
                "sLatitude": sLocation.Latitude ? sLocation.Latitude + "" : null,
                "sLongitude": sLocation.Longitude ? sLocation.Longitude + "" : null,
            }
        }
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            AxiosPost(`User/UpdateUserProfile`, objParam, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsOpenSnackbar(true);
                        let sSuccess = currentLanguage() == "th" ? "บันทึกข้อมูลสำเร็จ" : "Data is already saved."
                        setsMessageSnackbar(sSuccess)
                        setsSeveritySnackbar("success")
                        setIsAddTelExtention(false)

                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                    }
                })
            }, null, null)
        })

    }

    const onHandleChangeValue = async (eventValue, sField) => {

        switch (sField) {
            case "tel":
                form.setValue("sInputTel", null)
                form.clearErrors("sInputTel")
                setIsRequireInputTel(false)
                if (eventValue && eventValue.value === "-1") {
                    setIsRequireInputTel(true)
                }
                break;
            case "company":
                form.setValue("oAddress", null)
                form.setValue("sInputAddress", null)
                if (eventValue && eventValue.value) {
                    AxiosGet(`Company/GetCompanyAddress`, { "nUserID": DataUser.nUserID, "nCompanyID": eventValue.value, "IsAdd": false }, (res) => {
                        ResultAPI(res, null, () => {
                            setOptionAddress(res.result.data || [])
                            let chk1Option = (res.result.data || []).filter(f => f.value != "-1")
                            if (chk1Option.length === 1) {
                                form.setValue("oAddress", chk1Option[0])
                            }
                        })
                    });
                }
                if (sField === "Company") {
                    //กรอง สถานที่
                    if (eventValue && eventValue.value) {
                        AxiosGet(`Company/GetCompanyAddress`, { "nUserID": DataUser.nUserID, "nCompanyID": eventValue.value, "IsAdd": false }, (res) => {
                            ResultAPI(res, null, () => {
                                setOptionAddress(res.result?.data || [])
                            })
                        });
                    }
                }

                break;
            case "address":
                if (eventValue && eventValue.value === "-1") {
                    setIsAddAddress(true)
                }
                else {
                    setIsAddAddress(false)
                    setIsSetMap(false)
                }
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                break;
            case "inputaddress":
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                break;
        }
    }

    const onDeleteProfile =()=>{
        let sMesasge = currentLanguage() == "th" ? "คุณต้องการที่จะลบรูปประจำตัวใช่หรือไม่ ?" : "Do you want to delete profile ?"
        SwAlert.Confirm(AlertTitle.Confirm, sMesasge, () => {
            AxiosPost(`UploadProfile/DeleteProfile`, {}, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setarrProfile([])
                        setIsOpenSnackbar(true);
                        let sSuccess = currentLanguage() == "th" ? "ลบข้อมูลเรียบร้อยแล้ว" : "Data is already deleted."
                        setsMessageSnackbar(sSuccess)
                        setsSeveritySnackbar("success")
                        setIsAddTelExtention(false)

                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                    }
                })
            }, null, null)
          })
    }

    return (
        <>
            <div style={{ padding: !Layout1000 ? '2em' : '6em 2em' }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                    <Grid item xs={12}>
                        <InnerHeadRoutes
                            iconMUI={<ImProfile style={{ fontSize: '1.5em' }} />}
                            labal_Head={i18n(`${i18nField}.sHead`)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} data-aos="fade-right">
                        <div
                            style={{
                                width: '100%',
                                border: '1px solid #d5d5d5 !important',
                                padding: '16px',
                                borderRadius: '10px',
                                // backgroundColor: '#fff',
                            }}
                        >
                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item xs={12}>
                                    <div style={{display:'flex',justifyContent:'center'}}>
                                        <Badge
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            badgeContent={
                                                <IconButton
                                                    sx={{
                                                        width: 40,
                                                        height: 40,
                                                        border: '2px solid #fff'
                                                    }}
                                                    onClick={() => { onDeleteProfile() }}
                                                    style={{
                                                        backgroundColor: '#bdbdbd'
                                                    }}
                                                >
                                                    <DeleteForever style={{ color: '#000000' }} />
                                                </IconButton>
                                            }
                                        >
                                            <Avatar
                                                src={arrProfile.length == 0 ? DataUser?.sPathImage : arrProfile.length > 0 ? arrProfile[arrProfile.length - 1].sFileLink : UserAvatar}
                                                style={{
                                                    width: '12em',
                                                    height: '12em',
                                                    margin: '0 auto',
                                                    boxShadow: '5px 5px 13px 3px rgb(0 0 0 / 20%)',
                                                }}
                                            />
                                        </Badge>
                                    </div>
                                </Grid>
                                <Grid item >
                                    <UploadProfile
                                        id="sImageProfile"
                                        keyID={99}
                                        sTitle={""}
                                        IsRequired={false}
                                        arrFile={arrProfile || []}
                                        setarrFile={setarrProfile}
                                        IsFolder={false}
                                        IsFile={true}
                                        IsMultiple={false}
                                        Extension={[...Extension.Image_New]}
                                        IsDrag={false}
                                        nLimitFile={10}
                                        sLimitFile={"MB"}
                                        onClearFile={onClearFile}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid item style={{ padding: '0' }} data-aos="fade-left">
                        <Divider orientation="vertical" variant="middle" flexItem style={{ display: !Layout900 ? 'none' : 'block', minHeight: '300px', margin: '24px 8px 4px', border: '0.5px solid #d4d4d4', backgroundColor: '#d4d4d4' }} />
                    </Grid>
                    <Grid item xs={12} md={7.5} data-aos="fade-left">
                        <FormProvider {...form}>
                            {
                                DataUser.sUserType == "C"
                                    ?
                                    <>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ paddingTop: '5%' }}>
                                            <Grid item xs={12} sm={3}>
                                                <AutoCompleteSelect
                                                    name="oTitle"
                                                    options={OptionTitle}
                                                    label={i18n(`${i18nField}.sTitle`)}
                                                    required={true}
                                                />
                                            </Grid>
                                            {/* Firstname  */}
                                            <Grid item xs={12} sm={5}>
                                                <InputFormItem
                                                    id="sFirstname"
                                                    name="sFirstname"
                                                    label={i18n(`${i18nField}.sFirstname`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            {/* Lastname  */}
                                            <Grid item xs={12} sm={4}>
                                                <InputFormItem
                                                    id="sLastname"
                                                    name="sLastname"
                                                    label={i18n(`${i18nField}.sLastname`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            {/* Company  */}
                                            <Grid item xs={12}>
                                                <AutoCompleteSelect
                                                    name="oCompany"
                                                    options={OptionCompany}
                                                    label={i18n(`${i18nField}.sCompany`)}
                                                    required={true}
                                                    onChange={(event) => {
                                                        onHandleChangeValue(event, "company")
                                                    }}
                                                />
                                            </Grid>
                                            {/* Address  */}
                                            <Grid item xs={12}>
                                                <AutoCompleteSelect
                                                    name="oAddress"
                                                    options={OptionAddress}
                                                    label={i18n(`${i18nField}.sAddress`)}
                                                    required={true}
                                                    onChange={(event) => {
                                                        onHandleChangeValue(event, "address")
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ display: IsAddAddress === true ? 'block' : 'none' }}>
                                                <InputFormItem
                                                    id="sInputAddress"
                                                    name="sInputAddress"
                                                    label={i18n(`${i18nField}.sAddress`)}
                                                    required={true}
                                                    multiline={true}
                                                    rows={2}
                                                    fullWidth
                                                    onChange={(event) => {
                                                        onHandleChangeValue(event, "inputaddress")
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ display: IsAddAddress === true ? 'block' : 'none' }}>
                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="start" >
                                                    <Grid item>
                                                        <AddLocationAltIcon style={{ color: '#027db4' }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <div
                                                            onClick={() => {
                                                                setIsOpenMap(true)
                                                            }}
                                                            style={{
                                                                color: '#027db4',
                                                                cursor: 'pointer',
                                                                textDecoration: 'underline'
                                                            }}
                                                        >
                                                            <Typography>{i18n(`${i18nField}.sCFM`)}</Typography>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* Tel  */}
                                            <Grid item xs={12} sm={6} md={4}>
                                                <AutoCompleteSelect
                                                    name="oTel"
                                                    options={OptionTel}
                                                    label={i18n(`${i18nField}.sTel`)}
                                                    required={true}
                                                    onChange={(e) => { onHandleChangeValue(e, "tel") }}
                                                    // disabled={isAutoCreate}
                                                />
                                            </Grid>
                                            {
                                                form.getValues("oTel")?.value === "-1"
                                                    ?
                                                    <>
                                                        <Grid item xs={12} sm={12} md={8}>
                                                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                                                <Grid item xs={12} sm={12} md={5}>
                                                                    <InputFormItem
                                                                        id="sInputTel"
                                                                        name="sInputTel"
                                                                        label={i18n(`${i18nField}.sTel`)}
                                                                        required={true}
                                                                        fullWidth
                                                                        maxLength={10}
                                                                        onChange={(e)=>{
                                                                            if(e == "")
                                                                            {
                                                                                setIsAddTelExtention(false);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Grid>
                                                               { <Grid item xs={12} sm={12} md={'auto'}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={IsAddTelExtention}
                                                                                disabled={(!form.getValues("sInputTel"))}
                                                                                onChange={() => {
                                                                                    setIsAddTelExtention(!IsAddTelExtention);
                                                                                    form.setValue("sInputTelExtension", null)
                                                                                    form.clearErrors("sInputTelExtension")
                                                                                }}
                                                                            />
                                                                        }
                                                                        label={i18n(`${i18nField}.sTelExtension`)}
                                                                        labelPlacement="end"
                                                                    />
                                                                </Grid>}
                                                                {IsAddTelExtention &&
                                                                    <Grid item xs={12} sm={12} md={4}>
                                                                        <InputFormItem
                                                                            id="sInputTelExtension"
                                                                            name="sInputTelExtension"
                                                                            label={i18n(`${i18nField}.sTelExtension`)}
                                                                            required={true}
                                                                            fullWidth
                                                                            maxLength={10}
                                                                            />
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                    : null
                                            }
                                            {/* Email  */}
                                            <Grid item xs={12} sm={6}>
                                                <InputFormItem
                                                    id="sEmail"
                                                    name="sEmail"
                                                    label={i18n(`${i18nField}.sEmail`)}
                                                    required={true}
                                                    fullWidth
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <InputFormItem
                                                    id="sPTTOwner"
                                                    name="sPTTOwner"
                                                    label={i18n(`${i18nField}.sPTTOwner`)}
                                                    required={false}
                                                    fullWidth
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                                    <Grid item >
                                                        <BtnConfirm txt={i18n(`${i18nFieldCommon}.save`)} onClick={form.handleSubmit(() => { onSaveProfile() })} />
                                                    </Grid>
                                                    {
                                                        !isAutoCreate &&
                                                        <Grid item >
                                                            <BtnChangePassword txt={i18n(`${i18nFieldCommon}.ChangePassword`)} onClick={() => { form.clearErrors(); setIsOpenPassword(true); }} />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ paddingTop: '10%' }}>
                                            {/* Firstname  */}
                                            <Grid item xs={12} sm={6}>
                                                <InputFormItem
                                                    id="sFirstname"
                                                    name="sFirstname"
                                                    label={i18n(`${i18nField}.sFirstname`)}
                                                    required={true}
                                                    disabled={DataUser.sUserType == "E" ? true : false}
                                                    fullWidth
                                                />
                                            </Grid>
                                            {/* Lastname  */}
                                            <Grid item xs={12} sm={6}>
                                                <InputFormItem
                                                    id="sLastname"
                                                    name="sLastname"
                                                    label={i18n(`${i18nField}.sLastname`)}
                                                    required={true}
                                                    disabled={DataUser.sUserType == "E" ? true : false}
                                                    fullWidth
                                                />
                                            </Grid>
                                            {/* Email  */}
                                            <Grid item xs={12} >
                                                <InputFormItem
                                                    id="sEmail"
                                                    name="sEmail"
                                                    label={i18n(`${i18nField}.sEmail`)}
                                                    required={true}
                                                    fullWidth
                                                    disabled={DataUser.sUserType == "E" ? true : false}
                                                />
                                            </Grid>
                                            {
                                                DataUser.sUserType == "E"
                                                    ?
                                                    null
                                                    :
                                                    <Grid item xs={12} >
                                                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item >
                                                                <BtnConfirm txt={i18n(`${i18nFieldCommon}.save`)} onClick={form.handleSubmit(() => { onSaveProfile() })} />
                                                            </Grid>
                                                            {
                                                                !isAutoCreate
                                                                    ?
                                                                    <Grid item >
                                                                        <BtnChangePassword txt={i18n(`${i18nFieldCommon}.ChangePassword`)} onClick={() => { form.clearErrors(); setIsOpenPassword(true); }} />
                                                                    </Grid>
                                                                    : null
                                                            }
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </Grid>
                                    </>
                            }


                        </FormProvider>
                    </Grid>
                </Grid>
            </div >
            <ModalChangePassword
                IsOpen={IsOpenPassword}
                setIsOpen={setIsOpenPassword}
                sUserID={sUserID}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
            />
            <CpnPopUpMap
                setIsOpen={setIsOpenMap}
                IsOpen={IsOpenMap}
                sMaxWidth={"md"}
                setsLocation={setsLocation}
                setoLocationCurrent={setoLocationCurrent}
                oLocationCurrent={oLocationCurrent}
                onConfirm={() => {
                    setIsSetMap(true)
                }}
                onCancel={() => {

                }}
            />
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default Profile